module.exports = __webpack_public_path__ + "static/img/IMG_20150612_171639.e1b86cef.jpg";